import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dae270b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "root hide-pc"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("注意報警報(気象庁)")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("閾値超過履歴")

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useInitDataStore } from '@/stores/initDataStore'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const initDataStore = useInitDataStore()
const route = useRoute()
const isKomakiPublic = computed(() => {
  return initDataStore.initData.transactId === 'komaki-public'
})
const linkClass = (link: string) => (route.path === link ? 'active' : '')

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_unref(isKomakiPublic))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass([linkClass('/alerts'), "link"])
        }, [
          _createVNode(_component_router_link, { to: "/alerts" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass([linkClass('/alerts/threashold'), "link"])
        }, [
          _createVNode(_component_router_link, { to: "/alerts/threashold" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})